import { ReactComponent as PlusLogo} from './playstation-plus-logo.svg'

function CompCard({data, index}) {
    let plusLogo = (data.subscriptionService === "PS_PLUS")? <PlusLogo /> : ""

    return (
        <div className="col-sm-4 responsive-font-size" key={index.toString()}>
            <div className="card mb-5 shadow-sm">
                <svg className="bd-placeholder-img card-img-top" width="100%" height="35" focusable="false" role="img">
                    <title>{data.name}</title>
                    <rect width="100%" height="100%" fill="#55595c"></rect>
                    <text x="50%" y="50%" fill="#ffffff" dy=".5em">{data.platforms.map(
                        (el, index) => index>0?` / ${el}`: el)}</text>
                </svg>
                <img className="card-image" src={data.media_master} alt={data.name} />
                <div className="card-body card-text-box">
                    <div className="card-text card-title-box">
                        <strong>{data.name}</strong>
                    </div>
                    <div className="card-text">Platform: 
                        <strong> {data.platforms.map((el, index) => index>0? ` / ${el}`: el)} </strong>
                    </div>
                    <div className="card-text">Title ID:
                        <strong> {data.titleId} </strong>
                    </div>
                    <p></p>
                    <p className="plus-logo">{plusLogo}</p>
                </div>
            </div>
        </div>
    )
}
export default CompCard